import React from 'react';
import styled, { css } from 'styled-components';

import { CategoriesMobileDisplayOption, RadiusOption } from 'types/graphql';
import Imgix from 'shared/components/imgix';
import { CardProps } from './card.types';

const radiusOptions = {
  [RadiusOption.rounded]: '16px',
  [RadiusOption.roundedRectangle]: '12px',
  [RadiusOption.square]: 0,
};

export const LargeCard = ({
  radius,
  mobileDisplay,
  category,
  image,
  isHidden = false,
  isPreview = false,
}: CardProps): JSX.Element => (
  <Card $radius={radius} $mobileDisplay={mobileDisplay} $hidden={isHidden}>
    <Category>{category}</Category>

    <ImageWrapper>
      {isPreview ? <img src={image} alt='' /> : <Image src={`${image}?w=200&h=100`} htmlAttributes={{ alt: '' }} />}
    </ImageWrapper>
  </Card>
);

const Card = styled.li<{
  $radius: RadiusOption;
  $mobileDisplay: CategoriesMobileDisplayOption;
  $hidden: boolean;
}>`
  align-items: center;
  aspect-ratio: 1.14 / 1;
  background: #fff;
  border: 1px solid #e3e7e9;
  border-radius: ${({ $radius }) => radiusOptions[$radius]};
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  color: #121516;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  font-weight: 600;
  line-height: ${24 / 16};
  padding: 15px;
  position: relative;
  flex: 0 0 151px;

  ${({ $mobileDisplay, $hidden }) =>
    $mobileDisplay === CategoriesMobileDisplayOption.grid &&
    css`
      flex: 0 0 calc(50% - 6px);
      display: ${$hidden ? 'none' : 'flex'};
    `}
`;

const Category = styled.div`
  width: 100%;
`;

const ImageWrapper = styled.div`
  bottom: 0;
  height: 100%;
  overflow: hidden;
  position: absolute;
  width: 100%;
  overflow: hidden;

  /*
  This padding value sizes the image container to be 160px x 85px for the 214px x 187px tile...
  and dynamically sizes the image container to maintain the same aspect ratio for different tile sizes.
  For this to work with other tile sizes, the tile must keep the same width to height ratio (1.14:1)
  */
  padding: 42.3% 14.6% 9.4%;
`;

const Image = styled(Imgix)<{ src: string; htmlAttributes: any }>`
  display: block;
  margin: 0 auto;
  max-height: 100%;
  object-fit: contain;
`;
